// history.ts — zod schema for the widget history endpoint's query string (transcript-
// leadlevel spec §A). Mirrors `publicChatSchema`'s `sessionKey` bounds — the widget sends
// the exact same session key it already generated for chat.
import { z } from 'zod';

export const historyQuerySchema = z.object({
  sessionKey: z.string().min(8).max(100),
});
